import { Component, Input, Output, EventEmitter, OnDestroy, ElementRef } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-multi-option-button',
  standalone: true,
  imports: [NgClass, TranslateModule],
  templateUrl: './multi-option-button.component.html',
  styleUrl: './multi-option-button.component.scss'
})
export class MultiOptionButtonComponent implements OnDestroy {
  @Input() styleClass: string = 'primary';
  @Input() options: string[] = [];
  @Input() text: string = '';
  @Output() optionSelected = new EventEmitter<string>();
  @Input() showMenuIcon = false;
  @Input() showArrowDownIcon = false;
  @Input() disabled = false;
  isOpen: boolean = false;

  constructor(private elementRef: ElementRef) {
    // Bind the method to preserve 'this' context
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.handleClickOutside);
  }

  ngOnDestroy() {
    // Remove click listener when component is destroyed
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  toggleOptions() {
    this.isOpen = !this.isOpen;
  }

  onOptionClick(option: string) {
    this.optionSelected.emit(option);
    this.isOpen = false;
  }
}
